
import { useI18n } from "vue-i18n/index";
import { defineComponent, ref,onMounted,inject,provide,computed} from 'vue'
import { useRoute} from 'vue-router';
import { useStore } from "vuex";
//components
import btnBack from "@/components/buttons/btnBack.vue"
import DialogOrderDetail from "./modals/DialogOrderDetail.vue";

//services
import GlobalService from "@/core/services/GlobalService";
import moment from "moment";
import {
    errManager,
    dateParticipate,
    DownloadXLSXPDF,
    mbtoa
} from "@/core/config/Tools";

export default defineComponent({
    name: "PaymentControlDetails",
    components: {
        btnBack, DialogOrderDetail
    },
    setup() {
        const { t } = useI18n();
        const store = useStore();
        const route = useRoute();
        const loader = ref(false)
        const evento = ref<any>({})
        const { id } = route.params
        const search = ref('');
        provide("evento", evento)
        const idState = ref('');
        const payment_date = ref('');
        const listOrders = ref<any[]>([]);
        const itemOrder = ref<any>({});
        const DialogOrderDetailRef = ref<any>(null);

        const company = computed(() => {
            return store.getters.currentUser.company
        });

        const listStatus = computed(() => {
            return store.getters.currentUser.status_pagos
        });

        //detalle del evento
        const getDetails = async () => {
            loader.value = true
            await GlobalService.get(`api/events/${id}`, 'show')
                .then((res) => {
                    evento.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const getListOrders = async () => {
            loader.value = true
            await GlobalService.get(`api`, `orders?idregister=${id}&search=${search.value}&status=${idState.value}&payment_date=${payment_date.value}`)
                .then((res) => {
                    listOrders.value = res.data?.data
                    loader.value = false
                }).catch(({ response }) => {
                    listOrders.value = []
                    loader.value = false
                    errManager(response)
                })
        };

        const openModalDetails = (data: any) => {
            if(DialogOrderDetailRef.value){
                itemOrder.value = data
                DialogOrderDetailRef.value.openModal();
            }
        };

        const onResponseOrderDetails = (data) => {
            getListOrders();
        }

        onMounted(()=>{
            if(listStatus.value.length > 0)
             idState.value = listStatus.value.map((item) => item.id);
        })

        onMounted(() => {
            getDetails();
            getListOrders();
        })

        return {
            t,
            loader,
            id,
            evento,
            idState,
            listStatus,
            listOrders,
            moment,
            itemOrder,
            DialogOrderDetailRef,
            search,
            payment_date,

            //events
            company,
            mbtoa,
            dateParticipate,
            getDetails,
            DownloadXLSXPDF,
            getListOrders,
            openModalDetails,
            onResponseOrderDetails
        }
    },
})
